import { useLocation } from 'react-router-dom'
import {useOpen} from 'common/hooks'
import {Modal} from 'common/components'
import {Button} from 'common/components/V2'
import AddNewForm from './OrgDetailsForm'

interface Content {
  buttonLabel: string
  modalTitle: string
  Form: any
}

const TheContent: Record<string, Content> = {
  '/orgs': {
    buttonLabel: 'borrower',
    modalTitle: 'Borrower',
    Form: AddNewForm,
  },
  '/orgs/brokers': {
    buttonLabel: 'broker',
    modalTitle: 'Broker',
    Form: AddNewForm,
  },
}

export const AddButton = () => {
  const {pathname} = useLocation()
  const [isOpen, handleOpen, handleClose] = useOpen()

  const theContent = TheContent[pathname]
  const {Form} = theContent

  return (
    <>
      <Button $color='cyan' $size="small" onClick={handleOpen}>
        add {theContent.buttonLabel}
      </Button>
      <Modal
        title={'New organisation'} // {`New ${theContent.modalTitle}`}
        open={isOpen}
        onCancel={handleClose}
      >
        <Form onClose={handleClose} defaultOrgType={theContent.buttonLabel} />
      </Modal>
    </>
  )
}
